export const minEquity = (value: number) => {
  return value ? Math.ceil(value * 0.15) : 0;
};
